var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Message(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrkWqRsuEmwpViPxws7A9a",
    x1: 12.686,
    x2: 35.58,
    y1: 4.592,
    y2: 41.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#737be6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4750b3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrkWqRsuEmwpViPxws7A9a)",
    d: "M42,8H6c-1.105,0-2,0.895-2,2v26c0,1.105,0.895,2,2,2h8v7.998 c0,0.891,1.077,1.337,1.707,0.707L24.412,38H42c1.105,0,2-0.895,2-2V10C44,8.895,43.105,8,42,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,22h24c1.105,0,2-0.895,2-2v-2c0-1.105-0.895-2-2-2H12c-1.105,0-2,0.895-2,2v2 C10,21.105,10.895,22,12,22z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,21.5h24c0.828,0,1.5-0.672,1.5-1.5v-2c0-0.828-0.672-1.5-1.5-1.5H12c-0.828,0-1.5,0.672-1.5,1.5 v2C10.5,20.828,11.172,21.5,12,21.5z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30h18c1.105,0,2-0.895,2-2v-2c0-1.105-0.895-2-2-2H12c-1.105,0-2,0.895-2,2v2 C10,29.105,10.895,30,12,30z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,29.5h18c0.828,0,1.5-0.672,1.5-1.5v-2c0-0.828-0.672-1.5-1.5-1.5H12c-0.828,0-1.5,0.672-1.5,1.5 v2C10.5,28.828,11.172,29.5,12,29.5z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,26v2c0,0.552-0.448,1-1,1H12c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h18 C30.552,25,31,25.448,31,26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37,18v2c0,0.552-0.448,1-1,1H12c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h24 C36.552,17,37,17.448,37,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Message);
export default __webpack_public_path__ + "static/media/icons8-message.00b498dea915f844487bbcccee1122ae.svg";
export { ForwardRef as ReactComponent };